import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_slsodr_to_slsinv_consol_template_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  template_name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  company_json: fromDatatype.JsonDatatypeInterface;
  branch_json: fromDatatype.JsonDatatypeInterface;
  customer_json: fromDatatype.JsonDatatypeInterface;
  salesman_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_slsodr_to_slsinv_consol_template_hdr_RowClass
  implements bl_fi_slsodr_to_slsinv_consol_template_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  template_name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  company_json: fromDatatype.JsonDatatypeInterface;
  branch_json: fromDatatype.JsonDatatypeInterface;
  customer_json: fromDatatype.JsonDatatypeInterface;
  salesman_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
